import React from "react";

import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

import { labelOf, votingCenterLabel } from "../model";

import styles from "../../ElectoralGeographyPage.module.styl";

const TreeNode = ({
  type,
  item,
  level,
  selected,
  expanded,
  hasChildren,
  children,
  onClick,
  onContextMenu,
}) => {
  const disabledVotingCenter =
    type === "voting-center" && Number(item?.status) === 2;

  return (
    <div className={styles.treeGroup}>
      <button
        type="button"
        className={[
          styles.treeNode,
          styles[`level${level}`],
          styles[`node_${type.replace("-", "_")}`],
          selected ? styles.selectedNode : "",
          disabledVotingCenter ? styles.disabledVotingCenterNode : "",
        ].join(" ")}
        onClick={onClick}
        onContextMenu={onContextMenu ? (event) => {
          event.preventDefault();
          onContextMenu(event, type, item);
        } : undefined}
      >
        <span className={styles.treeTwisty}>
          {hasChildren ? (
            expanded ? (
              <ExpandMoreOutlinedIcon fontSize="small" />
            ) : (
              <ChevronRightOutlinedIcon fontSize="small" />
            )
          ) : null}
        </span>

        <span className={styles.treeIcon}>
          {type === "voting-center" ? (
            <PlaceOutlinedIcon fontSize="small" />
          ) : (
            <FolderOutlinedIcon fontSize="small" />
          )}
        </span>

        <span className={styles.treeLabel}>
          {type === "voting-center" ? votingCenterLabel(item) : labelOf(item)}
        </span>
      </button>

      {expanded && children ? (
        <div className={styles.treeChildren}>
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default TreeNode;
